import React, { useState } from "react";
import { FormSectionElements, ProgramContainer } from "src/entities/formTemplateDataType";
import { ReactComponent as CloseIcon } from '../../../../public/assets/css/ontario-design-system/icons/ontario-icon-close.svg';

interface Props {
    token?: string;
    programContainer: ProgramContainer;
    isEng: boolean;
    field: FormSectionElements;
    onButtonClick?: (data) => void;
    callback?: (p: ProgramContainer) => void;
    onRequestClose?: () => void;
}

const EhocmWithdrawModal: React.FC<Props> = ({programContainer, isEng, field, onButtonClick, onRequestClose, callback}) => {
    const [cancellationReason, setCancellationReason] = useState('')

    return (
        <div style={{margin: '1rem'}}>
            <div>
                <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
                    <h3>{isEng ? 'Withdraw application' : "Retirer la demande"}</h3>
                    <a style={{ color: 'inherit' }} href='#' onClick={(e) => { e.preventDefault(); onRequestClose()}}>
                        <CloseIcon />
                    </a>
                </div>

                <p>{isEng ? 'Are you sure you want to withdraw this application? This action cannot be undone.' : "Êtes-vous sûr de vouloir retirer cette demande? Cette action est irréversible."}</p>

                <div style={{marginBottom: '1rem'}}>
                    <label htmlFor="withdraw-reason" style={{fontWeight: 'bold', display: 'block', marginBottom: '0.5rem'}}>
                        {isEng ? 'Withdraw reason' : 'Raison du retrait'}
                    </label>
                    <select
                        id="withdraw-reason"
                        value={cancellationReason}
                        onChange={(e) => setCancellationReason(e.target.value)}
                        style={{width: '100%', padding: '0.5rem'}}
                    >
                        <option value="">{isEng ? '-- Select --' : '-- Sélectionner --'}</option>
                        <option value="Created in error">{isEng ? 'Created in error' : "Créé par erreur"}</option>
                        <option value="Withdrawn">{isEng ? 'Withdrawn' : 'Retiré'}</option>
                    </select>
                </div>

                <div style={{marginTop: '1rem'}}>
                    <button
                        className="ontario-button ontario-button--primary"
                        disabled={!cancellationReason}
                        onClick={() => onButtonClick({ cancellationReason })}>
                        {isEng ? 'Confirm withdraw' : 'Confirmer le retrait'}
                    </button>
                    <button className="ontario-button ontario-button--secondary" onClick={onRequestClose}>
                        {isEng ? 'Cancel' : 'Annuler'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EhocmWithdrawModal;
